import React from "react";

const TourButton = ({...buttonProps}) =>
    (
        <button
            {...buttonProps}
            className={"fixed bottom-0 right-0 w-10 h-10 mr-12 mb-8 text-indigo-600 duration-150 bg-indigo-50 rounded-lg hover:bg-indigo-100 active:bg-indigo-200"}
        >
            <svg className={"ml-2 w-6 h-6 duration-150"} version="1.1" fill="currentColor"
                 id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                 viewBox="0 0 281.232 281.232">
                <g>
                    <path d="M231.634,79.976v-0.751C231.634,30.181,192.772,0,137.32,0c-31.987,0-57.415,9.018-77.784,22.98
		c-11.841,8.115-12.907,25.906-4.232,37.355l6.326,8.349c8.675,11.444,24.209,12.532,36.784,5.586
		c11.46-6.331,23.083-9.758,34-9.758c18.107,0,28.294,7.919,28.294,20.75v0.375c0,16.225-15.469,39.411-59.231,43.181l-1.507,1.697
		c-0.832,0.936,0.218,13.212,2.339,27.413l1.741,11.58c2.121,14.201,14.065,25.71,26.668,25.71s23.839-5.406,25.08-12.069
		c1.256-6.668,2.268-12.075,2.268-12.075C199.935,160.882,231.634,127.513,231.634,79.976z"/>
                    <path d="M118.42,217.095c-14.359,0-25.993,11.64-25.993,25.999v12.14c0,14.359,11.64,25.999,25.993,25.999
		h22.322c14.359,0,25.999-11.64,25.999-25.999v-12.14c0-14.359-11.645-25.999-25.999-25.999H118.42z"/>
                </g>
            </svg>
        </button>
    )
export default TourButton